import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { useFormState } from "react-final-form";

import {
  useComponent,
  useLatestFundingRound,
  useNoDataErrorState,
} from "./hooks";
import ValuationPriceComponentRow from "./ValuationPriceComponentRow";

const FundingRoundPriceComponentRow = (props) => {
  const { values } = useFormState();
  const { currentValue } = useComponent(values, props.id);

  const [fundingRound, fundingRoundIsLoading] = useLatestFundingRound(
    props.companyId,
    values.valuation_date,
    !props.initialValue && Boolean(props.companyId)
  );

  const computedValue = useMemo(
    () =>
      props.initialValue
        ? props.initialValue
        : Number(fundingRound?.price_per_share) || null,
    [props.initialValue, fundingRound?.price_per_share]
  );

  const error = useNoDataErrorState(
    props.initialValue || !values.valuation_date || fundingRoundIsLoading,
    computedValue || currentValue
  );

  return (
    <ValuationPriceComponentRow
      {...props}
      errorText={error}
      editable={!props.initialValue}
      initialValue={computedValue}
    />
  );
};

FundingRoundPriceComponentRow.propTypes = {
  id: PropTypes.number,
  initialValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  companyId: PropTypes.string,
  name: PropTypes.string.isRequired,
};

export default FundingRoundPriceComponentRow;
